import { BaseWebComponent } from '../components/BaseWebComponent.js'
import { Source } from '../utils/types.js'
import { queryElement } from '../utils/utils.js'

const template = `
<style>
  .cqmt-map-layers-menu {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 25rem;
  }
  .cqmt-row {
    display: flex;
    gap: 6px;
  }
  .cqmt-rounded-container {
    flex-grow: 1;
    border-radius: 6px;
    background-color: var(--bunker-1000);
    padding: 1rem;
  }
  .cqmt-content-info {
    margin-top: 16px;
    border: 1px solid var(--bunker-50);
    border-radius: 6px;
    width: 100%;
  }
  .cqmt-content-container {
    padding: 2px 10px;
  }
  .cqmt-header-text {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 2px;
  }
  .cqmt-option-text {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 1px;
  }
  .cqmt-checkbox-container {
    margin: 12px 0;
  }
  .cqmt-sub-option-container {
    display: flex;
    align-items: center;
    margin: 10px 0 10px 40px;
  }
  .cqmt-sub-option-text {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.1%;
  }

  details {
    summary {
      cursor: pointer;
      list-style: none;

      &.single-layer-line {
        display: flex;

        [type=checkbox] {
          margin: 1px 4px 0 4px;
        }
      }

      &:not(.single-layer-line)::after {
        content: url('CQMT/assets/PlusIcon.svg');
        float: right;
        margin-top: -2px;
        padding-left: 10px;
      }

      [open] &:not(.single-layer-line)::after {
        content: url('CQMT/assets/MinusIcon.svg');
      }

      &::-webkit-details-marker {
        display: none;
      }
    }
  }

  input[type=checkbox] + label {
    cursor: pointer;
  }

  details summary input[type=checkbox] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    accent-color: var(--patina-500);
    border: 1px solid var(--bunker-50);
    border-radius: 6px;
    width: 18px;
    height: 18px;
    margin: 1px 10px 0 4px;
    cursor: pointer;
  }

  details summary input[type=checkbox]:hover {
    border: 1px solid #D3D8DE;
    box-shadow: 0 0 0 2px  rgba(87, 162, 132, 0.05), 0 0 0 2px  rgba(159, 250, 189, 0.20);
  }

  details summary input[type=checkbox]:focus-visible {
    border: 1px solid #D3D8DE;
    box-shadow: 0 0 0 2px  rgba(87, 162, 132, 0.05), 0 0 0 2px  rgba(159, 250, 189, 0.20);
    outline: 1px solid var(--patina-500);
    outline-offset: 2px;
  }

  details summary input[type=checkbox]:checked {
    background: var(--patina-500);
    border-color: var(--patina-500);
    position: relative;
  }

  details summary input[type=checkbox]:checked:hover {
    background: var(--patina-600);
    border-color: var(--patina-600);
  }

  details summary input[type=checkbox]:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 4px;
    height: 8px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -60%) rotate(40deg);
  }

  .single-layer-line {
    align-items: center;
  }

  .cqmt-sub-option-container .legend-color, .single-layer-line .legend-color {
    display: inline-block;
    margin: 0 8px 0 4px;
    padding: 2px;
    width: 14px;
    height: 14px;
    border: 1px solid var(--bunker-50);
    border-radius: 50%;
  }

  .legend-color > .legend-color-fill {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }

  dialog {
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.4s;
    transition-behavior: allow-discrete;

    border: 1px solid var(--bunker-50);
    border-radius: 8px;
    max-width: 50vw;
  }

  dialog[open] {
    opacity: 1;

    @starting-style {
      opacity: 0;
    }
  }

  dialog[open]::backdrop {
    background-color: black;
    opacity: 0.25;
  }

  .cqmt-dialog-container {
    padding: 8px;
  }
  .cqmt-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 16px;
    border-bottom: 1px solid var(--bunker-50);

    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: 1px;
  }
  .close-icon {
    cursor: pointer;
    filter: invert(100%) sepia(0%) saturate(1587%) hue-rotate(345deg) brightness(111%) contrast(101%);
  }
  .cqmt-dialog-body {
    width: 100%;
  }
  .cqmt-dialog-message {
    padding: 0px 8px;

    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.1%;
  }

  #mapLayersInfo {
    cursor: pointer;
  }
</style>

<div class="cqmt-map-layers-menu">
  <div class="cqmt-row">
    <div class="cqmt-rounded-container">
      <div class="cqmt-row" style="justify-content: space-between;">
        <span class="cqmt-header-text" style="padding: 0;">MAP LAYERS</span>
        <!-- <img id="mapLayersInfo" src="CQMT/assets/InfoIcon.svg" /> -->
      </div>
      <div class="cqmt-content-info">
        <div id="sourcesContainer" class="cqmt-content-container cqmt-option-text"></div>
      </div>
    </div>
  </div>
</div>

<dialog id="cqmtMapLayersDialog" class="cqmt-dialog-container">
  <div class="cqmt-dialog-header">
    <p id="cqmtDialogMapLayersText">Layer Information</p>
    <img id="dialogCloseIcon" src="CQMT/assets/CloseIcon.svg" class="close-icon" />
  </div>
  <div class="cqmt-dialog-body">
    <p id="cqmtDialogMapLayersMessage" class="cqmt-dialog-message"></p>
  </div>
</dialog>
`

export type MapLayersMenuProps = {
  sources?: Source[]
  selectedLayers?: Record<string, boolean>
}

type MapLayersMenuElement = HTMLElement & MapLayersMenuProps
export class MapLayersMenu
  extends BaseWebComponent
  implements MapLayersMenuElement
{
  private _sources: Source[]
  private _selectedLayers: Record<string, boolean>

  protected get template(): string {
    return template
  }

  constructor() {
    super()

    this._sources = []
    this._selectedLayers = {}

    this.attachShadow({ mode: 'open' })
    this.shadowRoot.innerHTML = template

    const dialog = queryElement(
      this.shadowRoot,
      HTMLDialogElement,
      '#cqmtMapLayersDialog',
    )
    // this.shadowRoot
    //   .querySelector('#mapLayersInfo')
    //   .addEventListener('click', () => {
    //     dialog.showModal()
    //   })

    this.shadowRoot
      .querySelector('#dialogCloseIcon')
      .addEventListener('click', () => {
        dialog.close()
      })
  }

  static get observedAttributes() {
    return ['sources', 'selectedlayers']
  }

  get sources() {
    return this._sources
  }
  set sources(newVal) {
    this._sources = newVal
    this.updateLayerOptionsDisplay()
    this.updateModalDisplay()
  }

  get selectedLayers() {
    return this._selectedLayers
  }
  set selectedLayers(newVal) {
    this._selectedLayers = newVal
  }

  updateModalDisplay() {
    const dialogMessage = this.shadowRoot.querySelector(
      '#cqmtDialogMapLayersMessage',
    )
    dialogMessage.innerHTML = ''

    this.sources.forEach((source) => {
      const sourceContainer = document.createElement('div')
      sourceContainer.style.marginBottom = '20px'

      const sourceTitle = document.createElement('h3')
      sourceTitle.innerHTML = `${source.name}<br><span style="font-size: 0.8em; color: #666;">Version: ${source.version}</span>`
      sourceTitle.style.marginBottom = '10px'
      sourceTitle.style.color = '#333'
      sourceTitle.style.paddingBottom = '2px'

      const layerList = document.createElement('p')
      layerList.style.margin = '0'

      const layerNames = source.layers.map((layer) => layer.name).join(', ')
      layerList.style.color = '#666'
      layerList.style.fontSize = '0.8em'
      layerList.textContent = `Layers: ${layerNames}`

      sourceContainer.appendChild(sourceTitle)
      sourceContainer.appendChild(layerList)
      dialogMessage.appendChild(sourceContainer)
    })
  }

  updateLayerOptionsDisplay() {
    if (this.sources && Array.isArray(this.sources)) {
      const sourcesContainer =
        this.shadowRoot.querySelector('#sourcesContainer')

      this.sources.forEach((source) => {
        source.layers.forEach((layer) => {
          const layerHasMultipleCategories = layer.layerCategories.length > 1
          const layerContainer = document.createElement('div')
          layerContainer.className = 'cqmt-checkbox-container'

          const expansionPanel = document.createElement('details')
          const summarySection = document.createElement('summary')
          summarySection.tabIndex = -1
          const layerInput = document.createElement('input')
          const layerLabel = document.createElement('label')

          layerInput.type = 'checkbox'
          layerInput.id = layer.name.replaceAll(' ', '')
          if (this.selectedLayers[layerInput.id]) {
            layerInput.checked = true
          }

          layerLabel.innerText = layer.name
          layerLabel.setAttribute('for', layerInput.id)

          summarySection.appendChild(layerInput.cloneNode(true))

          if (!layerHasMultipleCategories) {
            summarySection.classList.add('single-layer-line')
            const categoryLegend = document.createElement('div')
            categoryLegend.className = 'legend-color'

            const categoryLegendFill = document.createElement('div')
            categoryLegendFill.className = 'legend-color-fill'
            categoryLegendFill.style.backgroundColor =
              layer.layerCategories[0].color
            categoryLegend.appendChild(categoryLegendFill.cloneNode(true))
            summarySection.appendChild(categoryLegend.cloneNode(true))
          }
          summarySection.appendChild(layerLabel.cloneNode(true))

          expansionPanel.appendChild(summarySection.cloneNode(true))
          if (layerInput.checked) {
            expansionPanel.open = true
          }

          if (layerHasMultipleCategories) {
            layer.layerCategories.forEach((categoryLayer) => {
              const layerCategory = document.createElement('div')
              layerCategory.className =
                'cqmt-sub-option-container cqmt-sub-option-text'

              const categoryLegend = document.createElement('div')
              categoryLegend.className = 'legend-color'

              const categoryLegendFill = document.createElement('div')
              categoryLegendFill.className = 'legend-color-fill'
              categoryLegendFill.style.backgroundColor = categoryLayer.color
              categoryLegend.appendChild(categoryLegendFill.cloneNode(true))

              const categoryLabel = document.createElement('span')
              categoryLabel.textContent = categoryLayer.name

              layerCategory.appendChild(categoryLegend.cloneNode(true))
              layerCategory.appendChild(categoryLabel.cloneNode(true))
              expansionPanel.appendChild(layerCategory.cloneNode(true))
            })
          }

          layerContainer.appendChild(expansionPanel.cloneNode(true))
          sourcesContainer.append(layerContainer.cloneNode(true))
        })

        const mapLayers = this.shadowRoot.querySelectorAll('summary input')
        mapLayers.forEach((mapLayer) => {
          mapLayer.addEventListener('change', this.mapLayerClicked)
        })
      })
    }
  }

  mapLayerClicked(event) {
    const layerClicked = new CustomEvent('cqmt-map-layer-selection', {
      bubbles: true,
      cancelable: true,
      composed: true,
      detail: {
        layer: event.target.id,
        selected: event.target.checked,
      },
    })
    this.dispatchEvent(layerClicked)
  }

  attributeChangedCallback(attrName, oldVal, newVal) {
    if (attrName.toLowerCase() === 'sources') {
      this.sources = newVal
    }
  }
}

if (!window.customElements.get('cqmt-side-menu-map-layers')) {
  window.customElements.define('cqmt-side-menu-map-layers', MapLayersMenu)
}
